import { render, staticRenderFns } from "./FreePageTable.vue?vue&type=template&id=54a64bb8&scoped=true"
import script from "./FreePageTable.vue?vue&type=script&lang=js"
export * from "./FreePageTable.vue?vue&type=script&lang=js"
import style0 from "./FreePageTable.vue?vue&type=style&index=0&id=54a64bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a64bb8",
  null
  
)

export default component.exports